import Base64 from "./base64";
import { hex_md5 } from "./md5";
var pcInterface = {};

pcInterface.pcApi = {
  sendCode: "/web/sso/ssoSendCode", //获取验证码
  checkCode: "/web/sso/checkMCode", //检查验证码
  ssoLogin: "/web/sso/ssoLogin", //登录
  erweima: "http://pic.eju.leju.com/qrcode.jpg", //获取二维码
  checkImg: "/Settings/Findpwd/checkImageCode", //检查图片验证码
  isReg: "/Settings/Findpwd/isReg", //是否注册
  isPassword: "/Settings/Findpwd/checkPwd", //密码输入是否正确
  province: "/web/userinfo/city", //获取城市
  city: "/web/userinfo/district", //获取区
  cancelHouse: "/web/data/into?appkey=28d592f59cf7d4f11441e73c27ed4f22", //取消收藏楼盘
  cancelNews: "/web/data/intonews?appkey=28d592f59cf7d4f11441e73c27ed4f22", //取消收藏新闻
  postImg: "/web/upload/mobile", //图片上传
  saveMsg: "/web/userinfo/save", //保存个人信息
  logOut: "/web/sso/ssoLogout?key=",
  accountoff: "/web/sso/cancelAccount?key=",
  cLike: "/web/center/changeguess", //猜你喜欢换一换
  kfGcode: "/settings/booking/kft_mcode", //看房团报名获取验证码
  signUp: "/settings/booking/kft_signup", //看房团报名
  isbindphone: "/settings/bindMobile/checkThirdBindMobile", //检查第三方手机号是否已绑定
};
//表单验证
pcInterface.pcFormCheck = {
  types: {},
  errMsg: [],
  check: function (el, type, err) {
    var _this = this,
      _result = [],
      config = [],
      isSuccess = true;
    this.errMsg = [];
    $.each(type, function (index, item) {
      if (!_this.types[item]) {
        throw {
          name: "validation error",
          message: "no types",
        };
      }
      _result.push(_this.types[item].validate(el));
      if (!_this.types[item].validate(el)) {
        _this.errMsg.push(_this.types[item].errMessage);
      }
    });
    $.each(_result, function (index, item) {
      if (!item) {
        isSuccess = false;
      }
    });
    if (isSuccess) {
      return true;
    } else {
      err && err(this.errMsg);
    }
  },
};
//模板引擎
pcInterface.pcTemplate = (function () {
  var render, list, html;
  return function (data, fn) {
    if (arguments.length === 1) {
      render = template.compile(data);
    } else if (arguments.length === 2 && $.type(fn) === "function" && render) {
      if ($.type(data) === "object") {
        list = [];
        list.push(data);
      } else {
        list = data;
      }
      html = render({
        list: list,
      });
      fn.call(null, html);
    }
  };
})();
//上传图片
pcInterface.pcUploadImg = function (opts) {
  this.input = opts.input || null;
  this.callback = opts.callback || function () {};
  this.err = opts.err || function () {};
  this.maxSize = (opts.maxSize || 2) * 1024 * 1024;
  this.canvas = opts.canvas || null;
  this.width = opts.width || 0;
  this.height = opts.height || 0;
  this.type = "";
  this.size = 0;
  this.mime = { png: "image/png", jpg: "image/jpeg", jpeg: "image/jpeg" };
  this.addEvent.call(this);
};
pcInterface.pcUploadImg.prototype.addEvent = function () {
  var _this = this;
  this.input.on("change", function (event) {
    _this.getFileMsg.call(_this, event.target.files[0]);
  });
};
pcInterface.pcUploadImg.prototype.getFileMsg = function (file) {
  this.type = file.type;
  this.size = file.size;
  if (this.checkFile.call(this)) {
    this.readMsg.call(this, file);
  } else {
    this.err.call(this, "请上传不大于1m的图片");
  }
};
pcInterface.pcUploadImg.prototype.checkFile = function () {
  var next = true;
  //读取不到type处理
  if (!this.type) {
    this.type = this.mime[file.name.match(/\.([^\.]+)$/i)[1]];
  }
  //图片格式处理
  if (!/\/(jpg|jpeg|png|gif)/i.test(this.type)) {
    next = false;
  }
  //图片过大处理
  if (this.size > this.maxSize) {
    next = false;
  }
  return next;
};
pcInterface.pcUploadImg.prototype.readMsg = function (file) {
  var _this = this,
    reader = new FileReader();
  reader.onload = function (e) {
    var dataURL = reader.result;
    _this.createImg.call(_this, dataURL, file);
  };
  reader.readAsDataURL(file);
};
pcInterface.pcUploadImg.prototype.createImg = function (url, file) {
  var img = new Image(),
    _this = this;
  img.src = url;
  img.onload = setCanvas;
  function setCanvas() {
    var context = _this.canvas[0].getContext("2d"),
      c_num = (img.width * img.height) / 1000000;
    if (c_num > 1) {
      _this.handleBig.call(
        _this,
        context,
        img,
        img.width,
        img.height,
        c_num,
        file
      );
    } else {
      context.drawImage(
        img,
        0,
        0,
        img.width,
        img.height,
        0,
        0,
        _this.width,
        _this.height
      );
      _this.callback(_this.canvas[0].toDataURL(_this.type), file);
    }
  }
};
pcInterface.pcUploadImg.prototype.handleBig = function (
  ctx,
  img,
  width,
  height,
  num,
  file
) {
  var _this = this,
    orient,
    mpImg = new MegaPixImage(file);
  EXIF.getData(file, function () {
    orient = EXIF.getTag(this, "Orientation");
    if (+orient === 6) {
      mpImg.render(_this.canvas[0], { width: 42, height: 42, orientation: 6 });
    } else {
      mpImg.render(_this.canvas[0], { width: 42, height: 42 });
    }
    _this.callback(_this.canvas[0].toDataURL(_this.type), file);
  });
};
//下拉刷新模版模式
pcInterface.pullUpdate = (function () {
  var myScroll,
    stype = 0,
    page = 2;
  return function (
    wrapEle,
    loading,
    insertEle,
    api,
    tmpl,
    type,
    dur,
    done,
    s_type,
    status
  ) {
    if (typeof s_type === "number") {
      myScroll && myScroll.destroy();
      myScroll = null;
      stype = s_type;
      page = 2;
      $(wrapEle).data("isScrolling", "");
    }
    if (arguments.length > 1) {
      pcInterface.pcTemplate(tmpl);
      myScroll = new IScroll(wrapEle, {
        bounce: true,
        bounceEasing: "circular",
        bounceTime: 200,
        disableMouse: true,
        disablePointer: true,
        probeType: 3,
        HWCompositing: true,
      });
      myScroll.on("scroll", function () {
        if (this.y < -50) {
          $(".g_fix").removeClass("hide");
        } else {
          $(".g_fix").addClass("hide");
        }
      });
      myScroll.on("scrollEnd", function () {
        if (this.y < this.maxScrollY + 5 && !$(wrapEle).data("isScrolling")) {
          $(wrapEle).data("isScrolling", true);
          if (dur) {
            dur();
          }
          $.ajax({
            type: "GET",
            url: api,
            data: {
              page: page,
              typeid: type,
              supertype: stype,
              status: status,
            },
            dataType: "json",
            success: function (data) {
              if (data.data["length"] !== 0) {
                pcInterface.pcTemplate(data.data, function (html) {
                  $(insertEle).children().last().before(html);
                  setTimeout(
                    function () {
                      if (done) {
                        done();
                      }
                      myScroll.refresh();
                      $(wrapEle).data("isScrolling", "");
                      page++;
                    }.bind(this),
                    200
                  );
                });
              } else {
                $(loading).hide();
                $(wrapEle).data("isScrolling", true);
                done(true);
              }
            },
          });
        }
      });
    } else {
      myScroll && myScroll.destroy();
    }
  };
})();
//下拉刷新无模版模式
pcInterface.pullUpdateNotmpl = (function () {
  var myScroll,
    stype = 0,
    page = 2;
  return function (
    wrapEle,
    loading,
    insertEle,
    api,
    tmpl,
    type,
    dur,
    done,
    s_type,
    status
  ) {
    if (typeof s_type === "number") {
      myScroll && myScroll.destroy();
      myScroll = null;
      stype = s_type;
      page = 2;
      $(wrapEle).data("isScrolling", "");
    }
    if (arguments.length > 1) {
      pcInterface.pcTemplate(tmpl);
      myScroll = new IScroll(wrapEle, {
        bounce: true,
        bounceEasing: "circular",
        bounceTime: 200,
        disableMouse: true,
        disablePointer: true,
        probeType: 3,
        HWCompositing: true,
      });
      myScroll.on("scroll", function () {
        if (this.y < -50) {
          $(".g_fix").removeClass("hide");
        } else {
          $(".g_fix").addClass("hide");
        }
      });
      myScroll.on("scrollEnd", function () {
        if (this.y < this.maxScrollY + 5 && !$(wrapEle).data("isScrolling")) {
          $(wrapEle).data("isScrolling", true);
          if (dur) {
            dur();
          }
          $.ajax({
            type: "GET",
            url: api,
            data: {
              page: page,
              typeid: type,
              supertype: stype,
              status: status,
            },
            dataType: "json",
            success: function (data) {
              if (data.data["length"] !== 0) {
                var html = data.data.htmls;
                $(insertEle).children().last().before(html);
                setTimeout(
                  function () {
                    if (done) {
                      done();
                    }
                    myScroll.refresh();
                    $(wrapEle).data("isScrolling", "");
                    page++;
                  }.bind(this),
                  200
                );
              } else {
                $(loading).hide();
                $(wrapEle).data("isScrolling", true);
                done(true);
              }
            },
          });
        }
      });
    } else {
      myScroll && myScroll.destroy();
    }
  };
})();
//工具类
pcInterface.pcUtils = {};
//操作localStorage
pcInterface.pcUtils.optLocal = function () {
  this.isLocal = function () {
    var e = false;
    if ("localStorage" in win && null != win.localStorage)
      try {
        localStorage.setItem("test", "test"),
          localStorage.removeItem("test"),
          (e = true);
      } catch (t) {}
    return e;
  };
  this.setLocal = function (a, b) {
    try {
      localStorage.setItem(a, b);
    } catch (c) {}
  };
  this.getLocal = function (a) {
    try {
      return localStorage.getItem(a);
    } catch (b) {}
  };
  this.removeLocal = function (a) {
    try {
      localStorage.removeItem(a);
    } catch (b) {}
  };
};
//操作cookie
pcInterface.pcUtils.optCookie = function () {
  this.setCookie = function (name, value, days, domain) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      var expires = "; expires=" + date.toGMTString();
    } else {
      var expires = "";
    }
    var cstr =
      name +
      "=" +
      value +
      expires +
      "; path=/" +
      (domain ? "; domain=" + domain : "");
    document.cookie = cstr;
  };
  this.getCookie = function (name) {
    var t = doc.cookie.match(new RegExp("\\b" + name + "=([^;]+)"));
    return t ? t[1] : "";
  };
};
//加密解密
pcInterface.pcUtils.optPassword = function () {
  this.secretMethod = function (str) {
    var base = new Base64(),
      md5 = hex_md5(str),
      baseR = base.encode(str);
    return base.encode(md5.substr(0, 8) + baseR + md5.substr(10, 4));
  };
  this.decodeMethod = function (str) {
    var base = new Base64(),
      len = base.decode(str).length;
    return base.decode(base.decode(str).substr(8, len - 12));
  };
};
pcInterface.pcUtils.loadImage = function () {
  this.load = function (url, fn) {
    var img = new Image();
    img.src = url;
    if (img.complete) {
      fn.call(null, img);
      return;
    }
    img.onload = function () {
      fn.call(null, img);
      img = img.onload = null;
    };
  };
};
pcInterface.pcUtils.getSaoma = function () {
  this.start = function (ele, time, fn) {
    if (ele.length === 0 || $.type(time) !== "number") {
      return;
    }
    var curTime = time;
    this.current_el = ele;
    this.timer;
    if (this.current_el.val() === undefined) {
      this.current_el.text(curTime + "秒");
    } else {
      this.current_el.val(curTime + "秒");
    }
    this.timer = setInterval(
      function () {
        if (curTime === 0) {
          clearInterval(this.timer);
          if (this.current_el.val() === undefined) {
            this.current_el.text("获取验证码");
          } else {
            this.current_el.val("获取验证码");
          }
          fn.call(ele);
        } else {
          curTime--;
          if (this.current_el.val() === undefined) {
            this.current_el.text(curTime + "秒");
          } else {
            this.current_el.val(curTime + "秒");
          }
        }
      }.bind(this),
      1000
    );
  };
  this.end = function () {
    clearInterval(this.timer);
    if (this.current_el.val() === undefined) {
      this.current_el.text("获取验证码");
    } else {
      this.current_el.val("获取验证码");
    }
  };
};
pcInterface.pcUtils.optWhich = function (type) {
  return new pcInterface.pcUtils[type]();
};
export default pcInterface;
